const TOKEN_KEY = "vavlis.at";

// POST an SSE stream from the backend and call onChunk for every text delta. Payload lines are Python repr strings.
export async function streamAi(path, body, onChunk) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
    method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` }, body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const type = (ev.match(/^event: (\w+)/m) || [])[1] || "message";
      const data = (ev.match(/^data: ([\s\S]*)$/m) || [])[1] || "";
      if (type === "error") throw new Error(unrepr(data));
      if (type === "message") onChunk(unrepr(data));
    }
  }
}

const unrepr = (s) => {
  const t = s.trim();
  if (!/^['"]/.test(t)) return t;
  try { return JSON.parse(`"${t.slice(1, -1).replace(/\\'/g, "'").replace(/"/g, '\\"')}"`); } catch { return t.slice(1, -1); }
};
